import * as React from "react";
const SvgFiRrTachometerSlow = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-tachometer-slow_svg__a)">
      <path
        fill="#062147"
        d="M20.445 21.516a3.014 3.014 0 0 1-4.073.128l-1.026-.887a1 1 0 0 1-.103-1.41 1 1 0 0 1 1.41-.104l1.028.888a1 1 0 0 0 1.356-.036 10 10 0 1 0-14.113-.039 1.016 1.016 0 0 0 1.395.076l1.027-.889a1 1 0 1 1 1.308 1.514l-1.026.888a3.04 3.04 0 0 1-4.12-.175A12 12 0 0 1 19.516 3.64a11.994 11.994 0 0 1 .929 17.876M12 11q-.264 0-.518.068L7.707 7.293a1 1 0 0 0-1.414 1.414l3.775 3.775A2 2 0 1 0 12 11"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-tachometer-slow_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTachometerSlow;
